// @flow
import { downloadMultiple as downloadMultipleAPI } from '../../../HttpRequests/files';
import handleException from '../../../Core/Helpers/handleException';

export default (paths: Array<string>) => async () => {

  try {
    
    const data = { paths };

    const response = await downloadMultipleAPI({ data });

    // Create blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    
    // Extract filename from Content-Disposition header if available
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'download.zip';
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {

    handleException(error);

  }

}
